export var ContentRight;

(function (ContentRight) {
  ContentRight["CREATE_CONTENT"] = "CREATE_CONTENT";
  ContentRight["EDIT_CONTENT"] = "EDIT_CONTENT";
  ContentRight["GET_CONTENT"] = "GET_CONTENT";
  ContentRight["LIST_CONTENT"] = "LIST_CONTENT";
  ContentRight["READ_CONTENT"] = "READ_CONTENT";
})(ContentRight || (ContentRight = {}));